import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_PROGRAM_V3_URL ?? `${hostConfig.apiBaseUrl}/program-service-ts`;

class AggregateLeaderboardService {
  constructor() {
    this.apiClient = createAxiosInstance(baseUrl);
  }

  async getLeaderboardConfig(clientId) {
    return (
      await this.apiClient?.get(`/v3/aggregate-learning-leaderboard/config/${clientId}`, {
        errorContext: "Failed to get leaderboard config",
      })
    )?.data;
  } //getLeaderboardConfig

  async getLeaderboardWidget(clientId, { sort, userId } = {}) {
    return (
      await this.apiClient?.get(`/v3/aggregate-learning-leaderboard/widget/${clientId}`, {
        params: { sort, userId },
        errorContext: "Failed to get leaderboard widget",
      })
    )?.data;
  } //getLeaderboardWidget

  async getFullLeaderboard(clientId, { sort, filter1, filter2, page, limit } = {}) {
    return (
      await this.apiClient?.get(`/v3/aggregate-learning-leaderboard/full/${clientId}`, {
        params: { sort, filter1, filter2, page, limit },
        errorContext: "Failed to get full leaderboard",
      })
    )?.data;
  } //getFullLeaderboard

  async getLeaderboardUserProfile(clientId, userId) {
    return (
      await this.apiClient?.get(`/v3/aggregate-learning-leaderboard/user/${clientId}/${userId}`, {
        errorContext: "Failed to get leaderboard user profile",
      })
    )?.data;
  } //getLeaderboardUserProfile
}

export default AggregateLeaderboardService;
